import React from "react";

function Jacket1() {
  return (
    <>
      <path
        d="m 292.57839,489.88287 v 45.49001 q -3.74,0.48 -7.5,0.86 -2.94,0.3 -5.89,0.52 c -1.35,0.11 -2.7,0.19999 -4.05,0.29 q -7.87,0.47999 -15.87,0.47999 -6.12,0 -12.16,-0.27999 c -1.9,-0.09 -3.78,-0.2 -5.66,-0.33 -1.61,-0.11 -3.2,-0.24 -4.8,-0.38 q -4.66,-0.4 -9.28,-1 v -45.65 a 62.36,62.36 0 0 0 14.08,4.7 84.51,84.51 0 0 0 37.74,-0.39 94.52,94.52 0 0 0 13.39,-4.31001 z"
        style={{ fill: "#f6c752" }}
      />
      <path
        d="m 239.55481,493.77899 v 46.12584 c -1.57804,-0.10783 -3.13647,-0.23525 -4.70471,-0.37246 -3.045,-0.26137 -6.07693,-0.58809 -9.09579,-0.98016 -36.42069,-4.51329 -82.18023,-4.52599 -113.21054,-24.12078 -4.72898,-1.40075 8.13851,-14.17365 6.86432,-15.02639 13.05559,-14.70223 29.40448,-27.33637 50.04643,-37.13785 0.81353,-0.38226 1.81329,-0.77432 2.98946,-1.19579 0.86253,-0.30385 1.78387,-0.6077 2.80323,-0.98016 3.9206,-1.23498 8.99777,-2.6072 14.27096,-4.09701 v 0 c 6.09655,-1.70547 12.46751,-3.56775 17.75053,-5.54765 l 19.26973,28.63017 v 0 l 11.00708,10.06612 c 1.30137,1.18733 2.03265,2.87465 2.0093,4.63612 z"
        style={{ fill: "#3e436d" }}
      />
      <path
        d="m 390.3214,502.20828 c 0.24722,-2.22495 15.24582,18.36097 14.62833,18.74322 -21.97475,13.55089 -62.38221,6.00976 -87.44362,12.20989 -8.9596,2.22311 -18.03702,3.94108 -27.18936,5.14579 l -0.61749,0.0883 c -2.44384,0.31365 -4.89421,0.59462 -7.35112,0.84293 -1.92109,0.19603 -3.84546,0.36593 -5.77309,0.50968 v -45.96901 c 0.005,-1.73496 0.73753,-3.38826 2.01913,-4.5577 l 11.00707,-10.06614 0.098,-0.14702 v 0 l 19.42656,-28.8654 c 5.08698,2.48957 10.95808,4.18523 17.28984,6.61601 v 0 c 2.20534,0.83313 4.44989,1.75446 6.76303,2.82283 0.21564,0.098 0.41167,0.18623 0.6175,0.30384 2.5876,1.2056 5.12618,2.46998 7.57656,3.76378 20.32829,10.61502 36.26553,23.651 48.94865,38.55909 z"
        style={{ fill: "#3e436d" }}
      />
      <path
        d="m 222.51001,419.38563 -30.66888,27.36579 a 8.5273006,8.5273006 0 0 0 -0.0883,12.67332 c 5.16538,4.66552 15.21191,11.35013 34.7659,19.73042 z"
        style={{ fill: "#32314b" }}
      />
      <path
        d="m 293.67868,419.38563 30.65907,27.36579 a 8.5273006,8.5273006 0 0 1 0.0882,12.67332 c -5.16539,4.66552 -15.21191,11.35013 -34.7659,19.73042 z"
        style={{ fill: "#32314b" }}
      />
    </>
  );
}

export default Jacket1;
